"use client";

import Link from "next/link";
import Image from "next/image";

// Enhanced category data with image paths
let listCategoryWithFilter = [
  { 
    id: 1, 
    title: "GUITAR 1-2 TRIỆU", 
    slug: "guitar", 
    productFilterSlug: "guitar-1tr-2tr",
    description: "Sản phẩm chất lượng",
    badge: "NHẠC CỤ CHẤT LƯỢNG",
    imageSrc: "/anhxuong/custom/1.png",
    bgColor: "bg-red-600",
    textColor: "text-white"
  },
  { 
    id: 2, 
    title: "GUITAR 2-4 TRIỆU", 
    slug: "guitar", 
    productFilterSlug: "guitar-2tr-3tr",
    description: "Âm thanh tốt hơn",
    badge: "GUITAR CHẤT LƯỢNG CAO",
    imageSrc: "/anhxuong/custom/4.png",
    bgColor: "bg-yellow-500",
    textColor: "text-white"
  },
  { 
    id: 3, 
    title: "GUITAR CAO CẤP", 
    slug: "guitar", 
    productFilterSlug: "guitar-cao-cap",
    description: "Gỗ tốt nhất, âm thanh đỉnh cao",
    badge: "PREMIUM QUALITY",
    imageSrc: "/anhxuong/custom/5.png",
    bgColor: "bg-black",
    textColor: "text-yellow-400"
  },
  { 
    id: 4, 
    title: "GUITAR CUSTOM", 
    slug: "guitar", 
    productFilterSlug: "guitar-custom",
    description: "Chế tác riêng theo yêu cầu khách hàng",
    badge: "GUITAR CUSTOM",
    imageSrc: "/anhxuong/custom/6.png",
    bgColor: "bg-black",
    textColor: "text-yellow-400"
  },
    { 
    id: 5, 
    title: "GUITAR CÓ EQ", 
    slug: "guitar", 
    productFilterSlug: "guitar-co-eq",
    description: "Hệ thống pickup và EQ chuyên nghiệp",
    badge: "Guitar EQ",
    imageSrc: "/anhxuong/custom/7.png",
    bgColor: "bg-black",
    textColor: "text-yellow-400"
  },
  { 
    id: 6, 
    title: "GUITAR CÔNG NGHỆ", 
    slug: "guitar", 
    productFilterSlug: "guitar-cong-nghe",
    description: "Công nghệ hiện đại, vật liệu mới",
    badge: "TECH GUITAR",
    imageSrc: "/anhxuong/custom/8.png",
    bgColor: "bg-black",
    textColor: "text-yellow-400"
  },
  { 
    id: 7, 
    title: "PHỤ KIỆN GUITAR", 
    slug: "phu-kien", 
    productFilterSlug: null,
    description: "Dây đàn, capo, pick, túi đựng",
    badge: "Phụ kiện",
    imageSrc: "/anhxuong/custom/9.png",
    bgColor: "bg-black",
    textColor: "text-yellow-400"
  },
];

// Category Card Component - Vertical Design
const CategoryCard = ({ category }: { category: any }) => {
  const href = category.productFilterSlug && category.slug !== "/"
    ? `/danh-muc/${category.slug}?productFilterSlug=${category.productFilterSlug}`
    : `/danh-muc/${category.slug}`;

  return (
    <Link
      href={href}
      className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:scale-[1.02] h-[240px] sm:h-[340px]"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src={category.imageSrc}
          alt={category.title}
          priority = { true}
          fill
          quality={75}
          className="object-cover group-hover:scale-105 transition-transform duration-700"
          onError={(e) => {
            const target = e.currentTarget as HTMLImageElement;
            target.style.backgroundColor = '#374151';
          }}
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/30 transition-colors duration-500"></div>
      </div>

      {/* Content Overlay */}
      <div className="relative h-full flex flex-col justify-between p-6 sm:p-8">
        
        {/* Top Badge */}
        <div className="flex justify-start">
          <div className={`${category.bgColor} px-3 py-1.5 sm:px-4 sm:py-2 text-white text-[10px] sm:text-xs font-bold tracking-wider uppercase rounded`}>
            {category.badge}
          </div>
        </div>

        {/* Bottom Content */}
        <div className="space-y-4 sm:space-y-6">
          {/* Main Title - Large and Bold */}
          <h3 className={`text-xl sm:text-3xl  font-black ${category.textColor} leading-tight tracking-tight`}
              style={{ 
          
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
              }}>
            {category.title.split('\n').map((line:any, i:any) => (
              <div key={i}>{line}</div>
            ))}
          </h3>

          {/* Description */}
          <p className="text-white/90 text-xs sm:text-sm font-medium max-w-xs">
            {category.description}
          </p>

          {/* CTA Button */}
          <div className="inline-flex">
            <div className={`${category.bgColor} px-4 py-2 sm:px-6 sm:py-3 text-white text-xs sm:text-sm font-bold uppercase rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center gap-2`}>
              <span>Xem chi tiết</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Hover Effect Border */}
      {/* <div className={`absolute inset-0 border-4 ${category.bgColor} opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl pointer-events-none`}></div> */}
    </Link>
  );
};

const CustomCategoryPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        
        {/* Header Section */}
       <div className="flex items-center space-x-3 mb-4 justify-center ">
       
        <div className=" text-center">
       
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black uppercase flex items-center gap-x-2">
               <div className="w-2 h-6 bg-red-500 rounded-full"></div>
            <span className="text-gray-800">DANH MỤC </span>
            <span className="text-red-600 relative">
              SẢN PHẨM
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-red-600"></div>
            </span>
          </h2>
        </div>
        </div>


        {/* Category Grid - 2 Columns on Desktop, 1 on Mobile */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
          {listCategoryWithFilter.map((category) => (
            <CategoryCard key={category.id} category={category} />
          ))}
        </div>


      </div>
    </div>
  );
};

export default CustomCategoryPage;